module.exports = __webpack_public_path__ + "img/17.f926105b.jpg";